import React from 'react';

/**
 * ATELIA.AI Logo Component
 * First Iteration - Geometric/Triangular "A"
 * 
 * Clean, minimal triangular "A" symbol representing:
 * - Precision and modernity
 * - The convergence of fashion and technology
 * - Luxury through simplicity
 * 
 * Key characteristics:
 * - Geometric triangular shape
 * - Clean lines with slight taper
 * - Subtle horizontal element
 */
const AteliaLogo = ({ size = 40, color = '#FFFFFF', className = '' }) => {
  const height = size;
  const width = size * 0.9;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 90 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Main triangular "A" shape - geometric and clean */}
      {/* Left leg */}
      <path
        d="M10 92 L45 8"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Right leg */}
      <path
        d="M45 8 L80 92"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Crossbar - subtle and elegant */}
      <path
        d="M25 62 L65 62"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  );
};

/**
 * Full Logo with Text underneath
 */
export const AteliaLogoFull = ({ size = 60, color = '#FFFFFF', className = '' }) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <AteliaLogo size={size} color={color} />
      <span 
        className="mt-3 font-sans font-semibold tracking-[0.25em]"
        style={{ color, fontSize: size * 0.2 }}
      >
        ATELIA.AI
      </span>
    </div>
  );
};

/**
 * Horizontal Logo (Symbol + Text)
 */
export const AteliaLogoHorizontal = ({ size = 32, color = '#FFFFFF', className = '' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <AteliaLogo size={size} color={color} />
      <span 
        className="font-sans font-semibold tracking-[0.2em]"
        style={{ color, fontSize: size * 0.45 }}
      >
        ATELIA.AI
      </span>
    </div>
  );
};

export default AteliaLogo;
